import { createFileRoute } from "@tanstack/react-router";

import { calendarDayParam, stringParam } from "../../../lib/url-state";
import {
  OperatorsPage,
  type OperatorsSearch,
} from "../../../workspaces/production/pages/OperatorsPage";

/* Operators, tracked the way pods are: the day on the lanes and the operator whose day is
 * open are the address, so a floor manager can send the link about one person's day. */
export const Route = createFileRoute("/_console/production/operators")({
  validateSearch: (search: Record<string, unknown>): OperatorsSearch => ({
    date: calendarDayParam(search.date),
    operator: stringParam(search.operator),
  }),
  component: OperatorsRoute,
});

function OperatorsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <OperatorsPage search={search} onSearchChange={(next) => void navigate({ search: next })} />;
}
